import type { IconSvgObject } from './types';

const CheckIcon: IconSvgObject = [
  ["path", { d: "M5 12.9999L9.00004 17L19 7.00008", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CheckIcon;
